/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { AxiosError } from "axios";
import { MdHistory } from "react-icons/md";
import { format } from "date-fns";
import api from "../../services/api";
import { LocaSmartLayout } from "../../components/locasmart-layout";
import Listagem from "../../components/listagem";
import ModalForm from "../../components/modal-form";
import { useAppSelector } from "../../store/hooks";
import { obterIdTenent } from "../../services/seguranca";
import { ApiError, Campo } from "../../services/tipos";
import { Auditoria } from "../../services/tipos";
import { TipoFormulario } from "../../services/constantes";

function AuditoriaListagem() {
    const [auditorias, setAuditorias] = useState<Auditoria[]>([]);
    const [rowCount, setRowCount] = useState(0);
    const [paginationModel, setPaginationModel] = useState({ page: 0, pageSize: 10 });

    const [usuariosOpcoes, setUsuariosOpcoes] = useState<{label: string, value: string}[]>([]);
    const [carregando, setCarregando] = useState<boolean>(false);
    const [token] = useState(useAppSelector(state => state.token));
    
    // Filtros state
    const [dataInicio, setDataInicio] = useState<Date | null>(new Date());
    const [dataFim, setDataFim] = useState<Date | null>(new Date());
    const [usuarioSelecionado, setUsuarioSelecionado] = useState<string>("");
    const [acaoSelecionada, setAcaoSelecionada] = useState<string>("");
    const [entidadeSelecionada, setEntidadeSelecionada] = useState<string>("");
    const [chavePrimaria, setChavePrimaria] = useState<string>("");

    // Busca por movimentação (auditoria de uma locação + seus filhos)
    const [modoBusca, setModoBusca] = useState<string>("filtros");
    const [locacoesOpcoes, setLocacoesOpcoes] = useState<{ label: string, value: string }[]>([]);
    const [locacaoSelecionada, setLocacaoSelecionada] = useState<string>("");

    const modoBuscaOpcoes = [
        { label: "Por filtros", value: "filtros" },
        { label: "Por movimentação (locação)", value: "movimentacao" }
    ];

    const acoesOpcoes = [
        { label: "Criação", value: "Criação" },
        { label: "Edição", value: "Edição" },
        { label: "Exclusão", value: "Exclusão" }
    ];

    const entidadesOpcoes = [
        { label: "Veículo", value: "Veiculo" },
        { label: "Locatário", value: "Locatario" },
        { label: "Locação", value: "Locacao" },
        { label: "Pagamento", value: "Pagamento" },
        { label: "Lançamento", value: "Lancamento" },
        { label: "Serviço", value: "Servico" },
        { label: "Peça", value: "Peca" },
        { label: "Estoque", value: "Estoque" },
        { label: "Usuário", value: "Usuario" },
        { label: "Empresa", value: "Empresa" },
        { label: "Nota Fiscal (NFService)", value: "NFService" },
        { label: "Modelo de Contrato", value: "ModeloContrato" },
        { label: "Troca de Óleo", value: "TrocaDeOleo" },
        { label: "Vistoria Moto", value: "VistoriaMoto" },
        { label: "Vistoria Carro", value: "VistoriaCarro" }
    ];

    const [exibirModal, setExibirModal] = useState(false);
    const [auditoriaSelecionada, setAuditoriaSelecionada] = useState<Auditoria>({} as Auditoria);

    // Columns
    const colunas = [
        { 
            field: 'dataHora', 
            headerName: 'Data/Hora', 
            flex: 1, 
            renderCell: (params: any) => format(new Date(params.value), 'dd/MM/yyyy HH:mm:ss')
        },
        { field: 'nomeUsuario', headerName: 'Usuário', flex: 1 },
        { field: 'ip', headerName: 'IP', flex: 0.5 },
        { field: 'entidade', headerName: 'Tela', flex: 1 },
        { field: 'acao', headerName: 'Ação', flex: 0.5 },
        { field: 'chavePrimaria', headerName: 'Chave Primária', flex: 1 },
    ];

    // Details Fields
    const camposDetalhes: Campo[] = [
        { label: 'Data/Hora', nome: 'dataHora', tipo: 'text', required: false, linha: 1, coluna: 1, largura: 6, apenasLeitura: true },
        { label: 'Usuário', nome: 'nomeUsuario', tipo: 'text', required: false, linha: 1, coluna: 2, largura: 6, apenasLeitura: true },
        { label: 'IP', nome: 'ip', tipo: 'text', required: false, linha: 2, coluna: 1, largura: 3, apenasLeitura: true },
        { label: 'Tela', nome: 'entidade', tipo: 'text', required: false, linha: 2, coluna: 2, largura: 3, apenasLeitura: true },
        { label: 'Ação', nome: 'acao', tipo: 'text', required: false, linha: 2, coluna: 3, largura: 3, apenasLeitura: true },
        { label: 'Chave Primária', nome: 'chavePrimaria', tipo: 'text', required: false, linha: 2, coluna: 4, largura: 3, apenasLeitura: true },
        { label: 'Antes', nome: 'dadosAntigos', tipo: 'memo', required: false, linha: 3, coluna: 1, largura: 12, apenasLeitura: true },
        { label: 'Depois', nome: 'dadosNovos', tipo: 'memo', required: false, linha: 4, coluna: 1, largura: 12, apenasLeitura: true },
    ];

    useEffect(() => {
        carregarUsuarios();
        carregarLocacoes();
    }, []);

    useEffect(() => {
        buscar();
    }, [paginationModel]);

    const buscar = () => {
        if (modoBusca === "movimentacao") buscarMovimentacao();
        else buscarAuditorias();
    };

    const carregarUsuarios = async () => {
        try {
            const idEmpresa = obterIdTenent(token);
            const response = await api.get(`/UsuarioPorEmpresa/${idEmpresa}`);
            const opcoes = response.data.map((u: any) => ({
                label: u.nome,
                value: u.id
            }));
            setUsuariosOpcoes(opcoes);
        } catch (error) {
            console.error("Erro ao carregar usuários", error);
        }
    };

    const carregarLocacoes = async () => {
        try {
            const idEmpresa = obterIdTenent(token);
            const response = await api.get(`/LocacaoPorEmpresaSemPaginacao/${idEmpresa}`);
            const lista = Array.isArray(response.data) ? response.data : (response.data.items || []);
            const opcoes = lista.map((l: any) => {
                const placa = l.veiculo?.placa || "";
                const nome = l.locatario?.nome || "";
                const label = [placa, nome].filter(Boolean).join(" - ") || l.id;
                return { label, value: l.id };
            });
            setLocacoesOpcoes(opcoes);
        } catch (error) {
            console.error("Erro ao carregar locações", error);
        }
    };

    const buscarMovimentacao = async () => {
        if (!locacaoSelecionada) {
            setAuditorias([]);
            setRowCount(0);
            return;
        }
        setCarregando(true);
        try {
            const idEmpresa = obterIdTenent(token);
            const params = new URLSearchParams();
            params.append('idLocacao', locacaoSelecionada);
            params.append('page', (paginationModel.page + 1).toString());
            params.append('pageSize', paginationModel.pageSize.toString());

            const response = await api.get(`/Auditoria/Movimentacao/${idEmpresa}?${params.toString()}`);
            setAuditorias(response.data.items || []);
            setRowCount(response.data.totalCount || 0);
        } catch (error) {
            const err = error as AxiosError<ApiError>;
            toast.error(err.response?.data?.Mensagem || "Erro ao buscar movimentação");
        } finally {
            setCarregando(false);
        }
    };

    const buscarAuditorias = async () => {
        setCarregando(true);
        try {
            const idEmpresa = obterIdTenent(token);
            const params = new URLSearchParams();
            
            // Pagination
            params.append('page', (paginationModel.page + 1).toString());
            params.append('pageSize', paginationModel.pageSize.toString());

            // Ao buscar por chave primária, ignora o intervalo de datas (busca em todo o histórico)
            if (!chavePrimaria) {
                if (dataInicio) params.append('dataInicio', format(dataInicio, 'yyyy-MM-dd'));
                if (dataFim) params.append('dataFim', format(dataFim, 'yyyy-MM-dd'));
            }
            if (usuarioSelecionado) params.append('usuarioId', usuarioSelecionado);
            if (acaoSelecionada) params.append('acao', acaoSelecionada);
            if (entidadeSelecionada) params.append('entidade', entidadeSelecionada);
            if (chavePrimaria) params.append('chavePrimaria', chavePrimaria.trim());

            const response = await api.get(`/Auditoria/Listar/${idEmpresa}?${params.toString()}`);
            
            // Handle PagedResultDto
            setAuditorias(response.data.items || []);
            setRowCount(response.data.totalCount || 0);

        } catch (error) {
            const err = error as AxiosError<ApiError>;
            toast.error(err.response?.data?.Mensagem || "Erro ao buscar auditoria");
        } finally {
            setCarregando(false);
        }
    };

    const isDateString = (value: any): boolean => {
        if (typeof value !== 'string') return false;
        // Simple regex for ISO date format YYYY-MM-DD or YYYY-MM-DDTHH:mm:ss
        return /^\d{4}-\d{2}-\d{2}/.test(value);
    };

    const formatValue = (value: any): string => {
        if (value === true) return "Sim";
        if (value === false) return "Não";
        if (value === null || value === undefined) return "-";
        
        if (isDateString(value)) {
            const date = new Date(value);
            if (!isNaN(date.getTime())) {
                return format(date, 'dd/MM/yyyy HH:mm:ss');
            }
        }

        if (typeof value === 'object') return JSON.stringify(value);
        return String(value);
    };

    const formatarDadosAuditoria = (dadosJson: string | null): string => {
        if (!dadosJson) return "";
        try {
            const dados = JSON.parse(dadosJson);
            return Object.entries(dados)
                .filter(([chave]) => !['IdEmpresa', 'id', 'Id'].includes(chave)) 
                .map(([chave, valor]) => {
                    return `${chave}: ${formatValue(valor)}`;
                })
                .join('\n');
        } catch (e) {
            return dadosJson; 
        }
    };

    const handleVisualizacao = (auditoria: Auditoria) => {
        const auditoriaFormatada = {
            ...auditoria,
            dataHora: format(new Date(auditoria.dataHora), 'dd/MM/yyyy HH:mm:ss'),
            dadosAntigos: formatarDadosAuditoria(auditoria.dadosAntigos),
            dadosNovos: formatarDadosAuditoria(auditoria.dadosNovos)
        };
        setAuditoriaSelecionada(auditoriaFormatada);
        setExibirModal(true);
    };

    return (
        <LocaSmartLayout>
            <Listagem
                colunas={colunas}
                linhas={auditorias}
                nomeEntidade="Auditoria"
                nomePropriedade="nomeUsuario"
                carregando={carregando}
                IconeEntidade={MdHistory}
                exibirAcoesDeCrud={false}
                ocultarNovo={true}
                handleVisualizacao={handleVisualizacao}
                
                // Pagination props
                rowCount={rowCount}
                paginationModel={paginationModel}
                onPaginationModelChange={setPaginationModel}
                paginationMode="server"

                // Dummy handlers for required props
                handleCriar={() => {}}
                handleEditar={() => {}}
                handleExclusao={() => {}}
                handleSelecionarEntidade={() => {}}
                filtros={{
                    aoBuscar: () => {
                        // Reset to first page on new filter search
                        setPaginationModel(prev => ({ ...prev, page: 0 }));
                        buscar();
                    },
                    carregando: carregando,
                    ...(modoBusca === "filtros" ? {
                        datas: {
                            dataInicio: dataInicio,
                            dataFim: dataFim,
                            onChangeDataInicio: setDataInicio,
                            onChangeDataFim: setDataFim,
                            labelInicio: "Data Início",
                            labelFim: "Data Fim"
                        }
                    } : {}),
                    textos: modoBusca === "filtros" ? [
                        {
                            key: "chavePrimaria",
                            label: "Chave Primária",
                            placeholder: "Id da entidade",
                            value: chavePrimaria,
                            onChange: setChavePrimaria
                        }
                    ] : [],
                    dropdowns: modoBusca === "filtros" ? [
                        {
                            key: "modoBusca",
                            label: "Modo de busca",
                            placeholder: "Por filtros",
                            opcoes: modoBuscaOpcoes,
                            value: modoBusca,
                            onChange: setModoBusca,
                            multiSelect: false
                        },
                        {
                            key: "usuario",
                            label: "Usuário",
                            placeholder: "Todos",
                            opcoes: usuariosOpcoes,
                            value: usuarioSelecionado,
                            onChange: setUsuarioSelecionado,
                            multiSelect: false
                        },
                        {
                            key: "acao",
                            label: "Ação",
                            placeholder: "Todas",
                            opcoes: acoesOpcoes,
                            value: acaoSelecionada,
                            onChange: setAcaoSelecionada,
                            multiSelect: false
                        },
                        {
                            key: "entidade",
                            label: "Tela",
                            placeholder: "Todas",
                            opcoes: entidadesOpcoes,
                            value: entidadeSelecionada,
                            onChange: setEntidadeSelecionada,
                            multiSelect: false
                        }
                    ] : [
                        {
                            key: "modoBusca",
                            label: "Modo de busca",
                            placeholder: "Por movimentação",
                            opcoes: modoBuscaOpcoes,
                            value: modoBusca,
                            onChange: setModoBusca,
                            multiSelect: false
                        },
                        {
                            key: "locacao",
                            label: "Locação",
                            placeholder: "Selecione a locação",
                            opcoes: locacoesOpcoes,
                            value: locacaoSelecionada,
                            onChange: setLocacaoSelecionada,
                            multiSelect: false
                        }
                    ]
                }}
            />

            <ModalForm
                show={exibirModal}
                onHide={() => setExibirModal(false)}
                onCancel={() => setExibirModal(false)}
                titulo="Detalhes da Auditoria"
                tamanho="lg"
                modo={TipoFormulario.tpVisualizacao}
                campos={camposDetalhes}
                entidadeSelecionada={auditoriaSelecionada}
                carregando={false}
                apiConfig={{
                    endpoint: "auditoria",
                    requisicaoBemSucedida: () => {},
                    tratarErro: () => {},
                    idTenentCampo: "idEmpresa"
                }}
            />
        </LocaSmartLayout>
    );
}

export default AuditoriaListagem;
